import { render, staticRenderFns } from "./ListFactureClients.vue?vue&type=template&id=6c85d40e&scoped=true&"
import script from "./ListFactureClients.vue?vue&type=script&lang=js&"
export * from "./ListFactureClients.vue?vue&type=script&lang=js&"
import style0 from "./ListFactureClients.vue?vue&type=style&index=0&id=6c85d40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85d40e",
  null
  
)

export default component.exports